/* ===========================================================
   Entry do SITE PÚBLICO (landing + demo) — ADR §38.
   Um único bundle, auto-contido: SessionProvider + DemoProvider (mock),
   SEM OperatorProvider, SEM /admin, SEM /login, SEM backend.
   Mixpanel é inicializado aqui (1x no boot) — senão os eventos do funil viram
   no-op (track() exige ready). A SUPERFÍCIE (landing|demo) é fixada depois, por
   tela, via marcarSuperficie() — não no boot.
   =========================================================== */
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { SessionProvider } from "./app/session";
import { DemoProvider } from "./app/DemoProvider";
import { router } from "./app/routes";
import { initAnalytics } from "./analytics/mixpanel";
import "./styles/lucraa.css";

initAnalytics();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <SessionProvider>
    <DemoProvider>
      <RouterProvider router={router} />
    </DemoProvider>
  </SessionProvider>,
);
